import React from 'react';
import { ReactElement } from 'react';
import { Dropdown, DropdownButton  } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

export const SUPPORTED_LANGUAGES = {
    fr: { nativeName: 'Français' },
    en: { nativeName: 'English' }
};

export const PAGES_FULLY_TRANSLATED: string[] = [
    "/profile",
];

export interface PropsLanguageSwitcher {};

/**
 * Ce DropDown permet de changer la langue d'affichage partout sur l'application
 * qui utilise i18n pour gérer les chaines de caractères à écrire
 *
 * @param props du toogle de language
 * @returns un dropdown pour sélectionner la langue d'affichage
 */
export default function LanguageSwitcher(props: PropsLanguageSwitcher): ReactElement {
    const { t, i18n } = useTranslation();

    return (
        <DropdownButton
            id="dropdown-basic-button"
            drop="left"
            variant="outline-secondary"
            title={i18n.resolvedLanguage}
        >
            {
                Object.keys(SUPPORTED_LANGUAGES).map((language) => (
                    <Dropdown.Item onClick={() => i18n.changeLanguage(language)}>
                        {SUPPORTED_LANGUAGES[language].nativeName}
                    </Dropdown.Item>
                ))
            }
        </DropdownButton>
    );
}
